import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';
import { Toast } from '../../../../../Notification';

export const deleteTour = async ({ state, tourId, userId, removeTour, Toast, updateState }) => {
  console.log(`tourId: ${tourId}`);
  let notification = {type: 'success', message: 'Tour Deleted', description: `TourId: ${tourId}`};
  try {
   await removeTour(tourId, userId);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTour',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Tour Failed",
        description: `TourId: ${tourId}: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  // no need to refresh here, will happen after deleting Job
}

export const logStart = async ({userId, resource, day, logJobStart}) => {
  const operation = 3; // 3 = delete
  try {
    await logJobStart(userId, operation);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Start Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
      Toast(notification);
    }
  }
}

export const logFinish = async ({resource, logControlId, jobId, day, logJobFinish}) => {
    try {
      await logJobFinish(logControlId, jobId);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        console.log(error);
        let notification = {
          type: 'error',
          message: "Logging Job Finish Error",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
        Toast(notification);
      }
    }
}

export const removeJob = async ({resource, logControlId, userId, jobId, removeJob, day, updateState, refreshPage}) => {
  let notification = {type: 'success', message: 'Request Deleted', description: `For ${resource.name} on ${day}`};
  let parameters = {
    userId,
    jobId,
    logControlId
  };
  try {
    await removeJob(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeJob',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Request Failed",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}




// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/job/deleteJob.js